import { render, staticRenderFns } from "./GridDetails.html?vue&type=template&id=01d5a197&scoped=true&"
import script from "./GridDetails.js?vue&type=script&lang=js&"
export * from "./GridDetails.js?vue&type=script&lang=js&"
import style0 from "./GridDetails.scss?vue&type=style&index=0&id=01d5a197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d5a197",
  null
  
)

export default component.exports